import React from 'react';
import CallToast from './CallToast';
import IncomingCallModal from './IncomingCallModal';
import OutgoingCallModal from './OutgoingCallModal';
import VideoCallRoom from './VideoCallRoom';

/**
 * Single mount point for call UI.
 *   - CallToast: always renders while call is ringing (primary UI)
 *   - Incoming/OutgoingCallModal: only renders when user opens the full-screen view
 *   - VideoCallRoom: renders once the call is accepted/active
 * Each child short-circuits on its own based on state.
 */
const VideoCallRoot = () => (
  <>
    <CallToast />
    <IncomingCallModal />
    <OutgoingCallModal />
    <VideoCallRoom />
  </>
);

export default VideoCallRoot;
